import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button, Container, Row, Col, Table, FormControl, FormLabel, Alert } from 'react-bootstrap';
import { logout } from "./actions/auth.js";
import { useSelector } from "react-redux";
import UserDataService from "./services/user.serviceaux.js";
import Sidebar from "./Sidebar.js";
import ExportSidebar from './ProSideBar.js';
import { Link, useParams } from "react-router-dom";
import OrganigramaAreaDataService from './services/organigramaarea.service';
import { dtFormatter, PageHeader } from './AuxiliaryFunctions';
import CompetenciasAreasJuez from './CompetenciasAreasJuez';
import { FaEdit } from "react-icons/fa";
import { useDispatch } from 'react-redux';
import { set } from 'react-hook-form';
import UpdateUser from './UpdateUser.js';

const Title = styled.h2`
  text-align: center;
  margin-bottom: 1rem;
`;

const SectionTitle = styled.h3`
  margin-top: 2rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  margin-bottom: 0.5rem;
  font-weight: bold;
`;

const Input = styled.input`
  padding: 0.6rem;
  margin-bottom: 1rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
`;


const Message = styled.p`
  color: green;
  margin-top: 1rem;
  text-align: center;
`;

// Example styles
const styles = {
  container: {
    width: '100%',
    margin: 'auto auto',
    padding: '1rem',
    border: '1px solid #ccc',
    borderRadius: '8px',
    textAlign: 'center',
    fontFamily: 'Arial, sans-serif',
  },
  avatar: {
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    objectFit: 'cover',
    marginBottom: '1rem',
  },
};


const ViewUserProfile = (props) => {
  const dispatch = useDispatch();
  let params = useParams();
  const [profile, setProfile] = useState({});
  const profileid = params ? params.userid : null;
  const { user: currentUser } = useSelector((state) => state.auth);

  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);
  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');

  const [showPlain, setShowPlain] = useState(1); // Try with 1 and 0 to see the difference

  const [listofcompetenciasusuario, setListofJCompetenciasUsuario] = useState([]);  
  const [roles, setRoles] = useState([]);

  useEffect(()=> {

    OrganigramaAreaDataService.getListCompetenciasUsuario(profileid)
      .then(resp => {
        console.log(resp.data);
        setListofJCompetenciasUsuario(resp.data);
      })
      .catch((e) => {
        if (e.response.status == 401) {
          dispatch(logout())
          .then(() => {
            window.location.reload();
          });
        }
        else {
          console.log(e.response.data);
          setSuccmessage("");
          setShowsuccess(false);
          setErrmessage(e);
          setShowerror(true);
        }
      });  
          
    UserDataService.get(profileid) 
    .then(resp => {
      let respdata = resp.data[0];
      console.log(respdata);
      //respdata.roles = respdata.roles.map(rol => rol.id);
      setProfile(respdata);
      setRoles(respdata.roles);                 
    })
    .catch(err => {
      if (err.status == 401) {
        dispatch(logout())
        .then(() => {
          window.location.reload();
        });
      }
      else {
        console.log(err);
        setSuccmessage("");
        setShowsuccess(false);
        setErrmessage(err);
        setShowerror(true);
      }
    });      
  }, [])

  return (
    <>
    <Sidebar />
    <div style={{display:'flex', flexDirection:'row', gap:'20px'}}>      
      <ExportSidebar roles={currentUser.roles}/>
      <div style={{display:'block',width:'100%'}}>
        <Container style={{width:"80%"}}>
          <PageHeader />
          <Container>
            <h4 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Perfil de {profile.primernombre}</h4>
          </Container>
          <Row>
          <div
            className="card"
            style={{padding:'40px 40px',}}
          >
            <div style={styles.container}>
              <img src={"//ssl.gstatic.com/accounts/ui/avatar_2x.png"} alt={`${(profile.primerapellido + ' ' + (profile.segundoapellido?profile.segundoapellido:"")).trim() + ", " + (profile.primernombre + ' ' + (profile.segundonombre?profile.segundonombre:"")).trim()}'s avatar`} style={styles.avatar} />
              <h2>{(profile.primerapellido + ' ' + (profile.segundoapellido?profile.segundoapellido:"")).trim() + ", " + (profile.primernombre + ' ' + (profile.segundonombre?profile.segundonombre:"")).trim()}</h2>
            </div>            
            <div style={{display:'flex',flexDirection:'row',gap:'5px',flexWrap:'wrap',alignItems:'baseline',justifyContent:'space-between'}}>                
              <div style={{display:'flex',flexDirection:'column',gap:'0px',flexWrap:'wrap'}}>                
                {/**
                <div style={{display:'flex',flexDirection:'row',gap:'10px',flexWrap:'wrap'}}>
                  <label><strong>Nombre:</strong></label>
                  <label>{(profile.primerapellido + ' ' + (profile.segundoapellido?profile.segundoapellido:"")).trim() + ", " + (profile.primernombre + ' ' + (profile.segundonombre?profile.segundonombre:"")).trim()}</label>
                </div>
                */}

                <div style={{display:'flex',flexDirection:'row',gap:'5px',flexWrap:'wrap'}}>
                  <em><strong>Correo electrónico:</strong></em>
                  <em>{profile.email}</em>
                </div>

                <div style={{display:'flex',flexDirection:'row',gap:'5px',flexWrap:'wrap'}}>
                  <em><strong>CURP:</strong></em>
                  <em>{profile.curp}</em>
                </div>               

                <div style={{display:'flex',flexDirection:'row',gap:'5px',flexWrap:'wrap'}}>
                  <em><strong>Teléfono:</strong></em>
                  <em>{profile.telefonomovil}</em>
                </div>                         
                
                {/**
                <div style={{display:'flex',flexDirection:'row',gap:'10px'}}>
                  <label><strong>Fecha de nacimiento:</strong></label>
                  <label>{dtFormatter(new Date(profile.fechadenacimiento),1)}</label>
                </div>          

                <div style={{display:'flex',flexDirection:'row',gap:'10px'}}>
                  <label><strong>Banco:</strong></label>
                  <label>{profile.banco}</label>
                </div>                                                                                

                <div style={{display:'flex',flexDirection:'row',gap:'10px'}}>
                  <label><strong>CLABE:</strong></label>
                  <label>{profile.clabe}</label>
                </div> 
                */}

              </div>
              
              <div style={{display:'flex',flexDirection:'column',gap:'0px',flexWrap:'wrap',justifyContent:'end',alignItems:'stretch'}}>                              
                <div style={{display:'flex',flexDirection:'row',gap:'5px',flexWrap:'wrap'}}>
                  <em><strong>Area:</strong></em>
                  <em>{(profile.arean1Id?profile.arean1.nombrearea:null) + " - " + (profile.arean2Id?profile.arean2.nombrearea:null)}</em>
                </div>                                          

                <div style={{display:'flex',flexDirection:'row',gap:'5px'}}>
                  <em><strong>Salario:</strong></em>
                  <em>{(profile.salariodiarioesperado?"$"+parseFloat(profile.salariodiarioesperado).toFixed(2):"-")}</em>
                </div>                                                              

                {/**
                <div style={{display:'flex',flexDirection:'row',gap:'10px'}}>
                  <label><strong>Bio:</strong></label>
                  <label>{profile.bio}</label>
                </div>
                */}

                {/**
                <div style={{display:'flex',flexDirection:'row',gap:'5px'}}>
                  <label><strong>Roles de usuario:</strong></label>
                  {(roles.map(rol => {
                    return (
                      <label>{rol.rolename}</label>  
                    )
                  }))}
                </div>
                */}

              </div>  
            </div>

            <div style={{display:'flex',flexDirection:'row',gap:'10px'}}>   
              {/*                 
              <Button className='btn-secondary' lg={8} style={{maxWidth:"50px",maxHeight:'38px'}} as={Link} to={`/userprofile`}>
                <FaEdit />
              </Button>
              */}

              <UpdateUser 
                edituser = {profile}
                userid = {profileid}
                username = {profile.username}
                email = {profile.emails}
              />    
            </div>   

            <hr/>

            <div>
              <ListaCompUsuario  showPlain={showPlain} listOf={listofcompetenciasusuario} currentUser={currentUser} user={profileid}/>
            </div>
          </div>
          </Row>

          <Row>
            

          </Row>

          <Row className='mt-2'>
          {showerror && (
            <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
              <Alert.Heading>Error</Alert.Heading>
              <p>{errmessage}</p>
            </Alert>      
          )}
          {showsuccess && (
            <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
              <Alert.Heading>Hecho</Alert.Heading>
              <p>{succmessage}</p>
            </Alert>      
          )} 
          </Row>                  
        </Container>
      </div>
    </div>
    </>
  );
};

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'8%'}}>Competencia</th>
        {/*<th className='d-none d-sm-table-cell' style={{width:'20%'}}>Descripción competencia</th>*/}
        <th style={{width:'8%'}}>Fecha</th>
        {/**<th className='d-none d-sm-table-cell' style={{width:'8%'}}>Fecha fin</th>*/}
        <th style={{width:'8%'}}>Ver áreas</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {  
  
  if (props.listOf) {
    
    const rows = props.listOf.map((row, index) => { 
      return (
        <>
        
        <tr key={index}>        
          <td>
            {row.nombrecompetencia}
          </td>
          {/**
          <td className='d-none d-sm-table-cell'>
            {row.descripcioncompetencia}
          </td>          
          */}
          <td>  
            {dtFormatter(new Date(row.fechainicio),1)}
          </td>
          {/**
          <td>
            {row.nombreareaorposicion}
          </td>
          */}
          {/**
          <td className='d-none d-sm-table-cell' >  
            {dtFormatter(new Date(row.fechafin),1)}
          </td>   
          */}
          
          <td>
            <CompetenciasAreasJuez 
              organigramaid={row.id}  // organigramaId
              competenciaid={row.compid} 
              //userid={props.currentUser.id}
              userid={props.user}
              showPlain={props.showPlain}
            />
          </td>
          
        </tr>
        </>      
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const ListaCompUsuario = (props) => {        
  const showPlain = props.showPlain;  
  if (showPlain === 1) {
    return (
      <CompetenciasAreasJuez 
        organigramaid={"all"}  // organigramaId
        competenciaid={"all"} 
        //userid={props.currentUser.id}
        userid={props.user}
        showPlain={showPlain}
      />
    );
  }
  else {
    return (
    <Container>
      <Row>
        <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
          <TableHeader/>
          <TableBody showPlain={showPlain} listOf={props.listOf} currentUser={props.currentUser} user={props.user}/>
        </Table>
      </Row>
      <hr/>
    </Container>
    )
  }
};


export default ViewUserProfile;